//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { assign } from '~/assets/js/utils.js'
export default {
  data () {
    return {
      loginOrRegistration: 1, // 1 为登录, 2 为注册
      login: { icon: 'https://resources.interface003.com/web20/img/login/login.svg', name: this.$t('22534'), type: 1 },
      registration: { icon: 'https://resources.interface003.com/web20/img/login/login.svg', name: this.$t('22535'), type: 1 },
      logoData: [ // 登录方式
        // { icon: require('https://resources.interface003.com/web20/img/login/weixin.svg'), url: null, name: this.$t('22537'), type: 2 }, // 通过微信继续
        { icon: 'https://resources.interface003.com/web20/img/login/facdbook.svg', url: null, name: this.$t('22536'), type: 3 } // 通过Facebook继续
        // { icon: require('https://resources.interface003.com/web20/img/login/Google.svg'), name: this.$t('22538'), type: 4 }, // 通过Google继续
        // { icon: require('https://resources.interface003.com/web20/img/login/apple.svg'), name: this.$t('22539'), type: 5 } // 通过Apple继续
      ],
      moreSte: false, // 更多状态
      tripartite: []
    }
  },
  computed: {
    // 面包屑导航——首页
    breadHost () {
      return this.$store?.getters?.breadHome
    },
    // 完整的域名
    fullDomain () {
      return this.$store?.state?.fullHost
    },
    // 完整的地址
    completeUrl () {
      return (this.fullDomain + this.$route?.fullPath) || ''
    }
  },
  mounted () {
    this.getTripartite()
  },
  methods: {
    // 加载更多
    setMore () {
      const more = [
        { icon: 'https://resources.interface003.com/web20/img/login/Tuite.svg', name: this.$t('22540'), type: 6 }, // 通过Twitter登录
        { icon: 'https://resources.interface003.com/web20/img/login/live.svg', name: this.$t('22541'), type: 7 } // 通过line登录
      ]
      more.forEach(item => this.logoData.push(item))
      this.moreSte = false
    },
    // 获取三方地址
    async getTripartite () {
      const { succeed = false, extra = '', result = {} } = await this.$api.login.userThird()
      if (!succeed) return extra // 数据错误
      this.tripartite = result
      assign(this.logoData[0], { url: result[1]?.LoginUrl })
      // assign(this.logoData[1], { url: result[1]?.LoginUrl })
    }
  }
}
